// src/modules/IntegratedMessaging/hooks/useUpdateIntegrationVisibility.ts

import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { IntegratedMessagingApiAdapter } from '../adapters/IntegratedMessagingApiAdapter';

export interface UpdateIntegrationVisibilityPayload {
  id: number;
  visibility: 'public' | 'private';
  private_team_ids?: number[];
}

export const useUpdateIntegrationVisibility = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegratedMessagingApiAdapter(httpClient);

  return useMutation<void, Error, UpdateIntegrationVisibilityPayload>({
    mutationFn: ({ id, visibility, private_team_ids }) =>
      adapter.updateIntegrationVisibility(id, visibility, private_team_ids),
  });
};
